const APP_VERSION = '0.7.1';


// These Must Match The API Exactly
const MODEL_STATUS_PUBLISHED = 'published';
const MODEL_STATUS_DRAFT = 'draft';
// const MODEL_STATUS_TRASHED = 'trashed';

// Order Status: Must Match API Exactly
const ORDER_STATUS_PENDING = 'pending';
const ORDER_STATUS_SHIPPED = 'shipped';
const ORDER_STATUS_COMPLETED = 'completed';
const ORDER_STATUS_REFUNDED = 'refunded';

// Valid Plans
export const validPlans = 'basic_monthly';

// Valid File Types To Store : image/*,audio/*,video/*
// export const validFileTypes = '';
export const validFileTypes = 'image/*,video/*,.cr2,.nef,.dng,.raf,.arw,.heic';//.cr3
// export const validFileTypes = { accept: { 'image/*': ['.jpeg', '.jpg', '.png'] } }

// Trial
export const TRIAL_LENGTH = 14; // Days of free trial with no card.

export const TERMS = {
    LIBRARY: {
        singular: 'Collection',
        plural: 'Collections'
    },
    ALBUM: {
        singular: 'Photo Shoot',
        plural: 'Photo Shoots'
    }
}

// Export Everything.
export const config = {
    allowTeammates: true,
    allowMultipleAccounts: true,
    sessionId: 'capturecollab',
    roles: ['viewer', 'editor', 'admin', 'owner',],
    networkRoles: ['superadmin', 'networkadmin'],
    modelStatuses: [MODEL_STATUS_PUBLISHED, MODEL_STATUS_DRAFT],
    termsVersion: '1.0.0',
    termsLink: 'https://www.capturecollab.com/terms',
    currencies: ['usd'],
    defaultCurrency: 'usd',
    orderStatuses: [ORDER_STATUS_PENDING, ORDER_STATUS_SHIPPED, ORDER_STATUS_COMPLETED, ORDER_STATUS_REFUNDED],
    imageCacheLength: 10080, // minutes
    validPlans,
    validFileTypes,
    trialLenght: TRIAL_LENGTH,
    version: APP_VERSION
}


